import socketIOClient from "socket.io-client";
import { config } from "../constant";
import { dashboardAction } from "../store/slices/dashboard";
import { v4 as uuidv4 } from "uuid";
import { jwtDecode } from "jwt-decode";


export default class socketService {
  public static io: any;
  private static _instance: socketService | null = null;
  private socketId: string;

  private constructor(token: any, navigate: any, dispatch: any) {
    let userData: any = jwtDecode(token);

    this.socketId = localStorage.getItem("socketId") || uuidv4();
    localStorage.setItem("socketId", this.socketId);
    console.log("userData",userData)
    // let userData: any = jwt_decode(dispatch);

    socketService.io = socketIOClient(`${config().SOCKET_URL}`, {
      path: "/cvm-socket-service",
      // auth: { token: '', id: this.socketId },
      auth: { token: '', id: `${userData?.domainId}_${userData?.ext}` },

      transports: ["websocket"],
    });

    socketService.io.on("connect", () => {
      console.log("✅ socket connected");
    });

    socketService.io.on("disconnect", () => {
      console.log("❌ socket disconnected");
    });

    socketService.io.on("connect_error", (msg: any) => {
      console.warn("⚠️ connect error", msg);
    });

    socketService.io.on("reconnect", () => {
      console.log("🔄 socket reconnected");
    });

    socketService.io.on("cvm_chat_response", (msg: any) => {
      console.log("botttttttt",msg)
      if (msg) {
        console.log("AI response received:", msg);
    
        const botMsg = {
          id: Date.now(),
          sessionId: msg.sessionId,
          domainId: msg.domainId,
          message: msg.bot_response || msg.message,
          messageId: msg.messageId, // Prefer bot_response
          sender: "bot",
          isBot: 1,
        };
    
        dispatch(dashboardAction.setAiChat(botMsg));
        dispatch(dashboardAction.setTyping(false));
      }
    });
    
  }

  // Singleton initializer
  public static init(accessToken: any, navigate: any, dispatch: any): socketService {
    if (!socketService._instance) {
      socketService._instance = new socketService(accessToken, navigate, dispatch);
    }
    return socketService._instance;
  }

  public static sendAIChat(data: any) {
    if (socketService.io?.connected) {
      socketService.io.emit("cvm_chat_request", data);
    } else {
      console.warn("Socket not connected, cannot send message");
    }
  }

  public static destroy() {
    if (socketService.io) {
      socketService.io.disconnect();
      socketService._instance = null;
    }
  }

  public static isSocketConnected(): boolean {
    return !!socketService.io?.connected;
  }
}
